<template>
  <div
    class="conclusion"
    v-observe-visibility="{
      callback: VisibilityChanged,
      intersection: {
        threshold: 0.3,
      },
    }"
  >
    <div style="flex: 1">
      <div class="conclusion__title" v-html="conclusion.title"></div>
      <div class="conclusion__info info">
        <img
          class="info__img"
          :src="require('../assets/conclusion' + conclusion.graph + '.png')"
        />
        <div class="info__content">
          <div class="info__content--subtitle">{{ conclusion.subtitle }}</div>
          <div
            class="info__content--paragraph"
            v-for="(paragraph, i) in conclusion.content"
            :key="i"
            v-html="paragraph"
          ></div>
        </div>
      </div>
    </div>
    <div class="conclusion__next" />
  </div>
</template>

<script>
export default {
  name: "ConclusionItem",
  data() {
    return {
      isInView: false,
    };
  },
  props: {
    conclusion: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    VisibilityChanged() {},
  },
};
</script>

<style lang="scss" scoped>
.conclusion {
  padding: 21px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  @media (min-width: 768px) {
    max-width: calc(100vw - 302px);
    padding: 21px 24px;
  }

  &__title {
    font-weight: 900;
    font-size: 26px;
    line-height: 38px;
    color: #009944;
    text-align: center;
    margin-bottom: 14px;
    @media (min-width: 768px) {
      font-size: 42px;
      line-height: 63px;
      max-width: 1017px;
      margin: 0 auto;
      margin-bottom: 0;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 1200px) {
      flex-direction: row;
      margin-top: 24px;
    }
    &__img {
      margin: 0 auto;
      max-width: 100%;
      @media (min-width: 1200px) {
        max-height: calc(100vh - 85px - 42px - 190px);
        flex: 1;
        margin: 0 0 0 114px;
      }
      &:hover {
        transform: scale(1.1);
      }
    }
    &__content {
      padding: 23px 15px 47px 15px;
      background: #ffffe7;
      border: 3px solid #009944;
      border-radius: 62px;
      margin: 0 auto;
      height: fit-content;
      margin-top: 14px;
      min-height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @media (min-width: 1200px) {
        padding: 32px;
        min-width: 384px;
        width: 384px;
        margin-left: 29px;
        margin-right: 86px;
        min-height: 495px;
      }

      &--subtitle {
        font-weight: 700;
        font-size: 22px;
        line-height: 32px;
        text-align: center;
        text-decoration-line: underline;
        color: #009944;
        // margin-bottom: 23px;
        @media (min-width: 768px) {
          font-size: 28px;
          line-height: 41px;
        }
      }

      &--paragraph {
        font-weight: 350;
        font-size: 16px;
        line-height: 24px;
        color: #009944;
        &:not(:first-child) {
          margin-top: 2em;
        }
        @media (min-width: 768px) {
          font-size: 18px;
          line-height: 26px;
        }
      }
    }
  }

  &__next {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 24.2px 14px 0 14px;
    border-color: #009945 transparent transparent transparent;
    margin-top: 20px;

    &:hover {
      cursor: pointer;
    }
    @media (min-width: 768px) {
      transform: translate(0, -100%);
    }
  }
}
</style>
